import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { environment as ENV } from '@environment';
import { HotelProvider } from '@hotels/hotel-results/entities/hotel-searched';
import { Countries } from '@ux/entities/country.enum';

@Component({
  selector: 'app-marriott-welcome-banner',
  templateUrl: './marriott-welcome-banner.component.html',
  styleUrls: ['./marriott-welcome-banner.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MarriottWelcomeBannerComponent {

  @Input() isPrime: boolean;
  @Input() bookingSource: HotelProvider;
  @Input() activeBonvoyNumber = false;

  public readonly imageBasePath: string = 'web/travel/marriott';
  public countryCode = ENV.countryInfo.iso_code;

  constructor() { }

  get isMX(): boolean {
    return this.countryCode === Countries.Mexico;
  }

  get imageName(): string {
    return this.isMX ? 'Welcome-Bonvoy-MX.png' : 'Welcome-Bonvoy-CO.png';
  }

  get showBanner(): boolean {
    return this.isPrime && this.bookingSource === HotelProvider.MarriottBonvoy && !this.activeBonvoyNumber;
  }

}
